<template>
  <div>
    <div :class="['select', selectState]" @click="start">
      <div class="select__content">
        <div :class="['select__content-prompt', selectState]">
          {{ title }}
        </div>
        <div :class="['select__content-date', selectState]">
          {{ selectContent }}
        </div>
      </div>
      <div :class="['select__image', selectState]" />
    </div>
    <transition>
      <div v-if="isDropdown" class="select__dropdown">
        <div
          v-for="(item, index) in list"
          :key="index"
          class="select__dropdown-item"
          @click="selectChanged(item, index)"
        >
          {{ item.name }}
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { DOUBLE_SELECT_CLASSES, DOUBLE_SELECT_STATUSES } from './const'

export default {
  name: 'DoubleSelectInfo',
  props: {
    title: {
      type: String,
      default: '',
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectContent: '',
      selectStatus: DOUBLE_SELECT_STATUSES.init,
    }
  },
  computed: {
    selectState() {
      return DOUBLE_SELECT_CLASSES[this.selectStatus]
    },
    isDropdown() {
      return this.selectStatus === DOUBLE_SELECT_STATUSES.open
    },
  },
  methods: {
    start() {
      this.selectStatus = DOUBLE_SELECT_STATUSES.open
      this.selectContent = ''
      this.$emit('select-changed', null)
    },
    selectChanged(value, index) {
      this.selectStatus = DOUBLE_SELECT_STATUSES.success
      this.selectContent = value.name
      this.$emit('select-changed', value.id)
    },
  },
}
</script>

<style lang="sass" scoped>
.select
  display: flex
  justify-content: space-between
  align-items: center
  width: 100%
  height: 5.6rem
  padding: 0 2rem 0 1.6rem
  border-radius: 0.8rem
  background: #F8F8F8
  cursor: pointer

  &.success
    border: 1px solid #28B411

  &__image
    width: 1.6rem
    height: 1.6rem
    margin-top: 0.2rem
    background: url("~@/assets/img/new-angle-down.svg")
    background-size: cover
    cursor: pointer
    transition: transform .3s ease

    &.open
      transform: rotateX(-180deg)
      transform-origin: center center

  &__content
    display: flex
    flex-direction: column
    justify-content: center
    padding: 0.6rem 0

    &-date
      height: 0
      padding: 0
      border-width: 0
      outline: none
      font-size: 0
      background: #F8F8F8
      transition: height .3s ease
      &.success
        height: 2.4rem
        font-size: 1.6rem
        color: #181818

    &-prompt
      font-size: 1.6rem
      color: #5C5C5C
      transition: all .3s ease
      &.success
        margin-bottom: .4rem
        font-size: 1.2rem
        font-weight: 700
        line-height: 1.6rem
        color: #3AC922
  &__dropdown
    margin-top: .8rem
    box-shadow: 0 0 1rem rgba(132, 132, 132, 0.15)
    border-radius: .4rem
    height: fit-content
    max-height: 19.2rem
    overflow: scroll

    &-item
      padding: 1.4rem 1.6rem
      font-weight: 400
      font-size: 1.6rem
      line-height: 2rem
      color: #181818
      &:hover
        color: $mainColor
</style>
